import { SerializeMap } from "lib/serializerUtils";

export const insuranceRatesSerializeMap: SerializeMap<InsuranceRates> = {
  adminRate: "admin_rate",
  extendedAdminRate: "extended_admin_rate",
  extendedRate: "extended_rate",
  insuranceType: "insurance_type",
  insuredDefinedByProvider: "insured_defined_by_provider",
  providerExtendedRate: "provider_extended_rate",
  providerId: "provider_id",
  providerStandardRate: "provider_standard_rate",
  standardRate: "standard_rate",
};
